export const SCHWEIZER_SYSTEM_SORTIERUNG = {
    PUNKTE: {id: "PUNKTE", label: "Punkte"},
    BUCHHOLZ: {id: "BUCHHOLZ", label: "Buchholz"},
    FEINBUCHHOLZ: {id: "FEINBUCHHOLZ", label: "Feinbuchholz"},
    GEWONNENE_SPIELE: {id: "GEWONNENE_SPIELE", label: "Gewonnene Spiele"},
    LEG_DIFFERENZ: {id: "LEG_DIFFERENZ", label: "Leg-Differenz"},
    GEWONNENE_LEGS: {id: "GEWONNENE_LEGS", label: "Gewonnene Legs"},
    DIREKTER_VERGLEICH: {id: "DIREKTER_VERGLEICH", label: "Direkter Vergleich"},
};

export const SCHWEIZER_SYSTEM_SORTIERUNG_STANDARD = Object.keys(SCHWEIZER_SYSTEM_SORTIERUNG);

// Sortierung von Turnieren, an denen noch keine Sortierung hinterlegt ist.
export function getSchweizerSystemSortierungBisher(buchholzWertung) {
    return SCHWEIZER_SYSTEM_SORTIERUNG_STANDARD
        .filter(id => buchholzWertung || (id !== SCHWEIZER_SYSTEM_SORTIERUNG.BUCHHOLZ.id && id !== SCHWEIZER_SYSTEM_SORTIERUNG.FEINBUCHHOLZ.id));
}
